<!--
  全站铃铛：消息中心唯一入口。click 直达消息中心页（单表面，无下拉）；
  有未读时展示数字徽标（超 99 显示 99+），计数数据源为 MessageService.unreadCount
-->
<script lang="ts" setup>
import { computed } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import iconNotificationWhite from '@core/assets/image/icon/icon-notification-white.svg';
import iconNotification from '@core/assets/image/icon/icon-notification.svg';
import { MessageService } from '@core/services/message.service';

const props = defineProps<{ white?: boolean }>();

const service = useService(MessageService);

const iconUrl = computed(() =>
  props.white ? iconNotificationWhite : iconNotification,
);

// 未读总数直接作徽标计数：0 时 a-badge 自动隐藏；超 overflow-count(99) 显示 99+
const unreadTotal = computed(() => service.unreadCount.total ?? 0);

// 数字红底样式（token error 色），与消息中心页 tab 气泡一致；提取为常量避免模板内联对象
const badgeStyle = { backgroundColor: '#f53f3f' };
</script>

<template>
  <div
    v-track:msg_bell_click.click="service.getBellTrackData()"
    class="h-6 w-6 cursor-pointer rounded-sm hover:opacity-75"
    @click="service.goToMessageCenter()"
  >
    <a-badge :count="unreadTotal" :number-style="badgeStyle" :offset="[-3, 3]">
      <img class="h-6 w-6" :src="iconUrl" alt="消息中心" />
    </a-badge>
  </div>
</template>
